export const AppStage = Object.freeze({
    DEVEL: Symbol('devel'),
    STAGING: Symbol('staging'),
    PRODUCTION: Symbol('production'),
    UNKNOWN: Symbol('unknown'),
})
